import {
  ModelSegmentAliasEventParams,
  ModelSegmentGroupEventParams,
  ModelSegmentPageEventParams,
  ModelSegmentTrackEventParams,
} from '../hooks/useSegment';

export const modelSegmentTrackEventParams: ModelSegmentTrackEventParams = ({
  analyticsTrackParams,
  analyticsTrackFn,
}) => {
  const { eventName, properties, options, callback } = analyticsTrackParams;

  return analyticsTrackFn(eventName, properties, options, callback);
};

export const modelSegmentPageEventParams: ModelSegmentPageEventParams = ({
  analyticsPageParams,
  analyticsPageFn,
}) => {
  const categoryName = analyticsPageParams?.categoryName;
  const name = analyticsPageParams?.name;
  const properties = analyticsPageParams?.properties;
  const options = analyticsPageParams?.options;
  const callback = analyticsPageParams?.callback;

  const params = analyticsPageParams || {
    categoryName,
    name,
    properties,
    options,
    callback,
  };

  return !!Object.values(params).filter(Boolean).length
    ? analyticsPageFn(categoryName, name, properties, options, callback)
    : analyticsPageFn();
};

export const modelSegmentGroupEventParams: ModelSegmentGroupEventParams = ({
  analyticsGroupParams,
  analyticsGroupFn,
}) => {
  const { groupId, traits, callback, options } = analyticsGroupParams;

  return analyticsGroupFn(groupId, traits, options, callback);
};

export const modelSegmentAliasEventParams: ModelSegmentAliasEventParams = ({
  analyticsAliasParams,
  analyticsAliasFn,
}) => {
  const { userId, options, previousId, callback } = analyticsAliasParams;

  return analyticsAliasFn(userId, previousId, options, callback);
};
